import React from 'react';
// containers
import Home from './containers/Home';
import About from './containers/About';
import Values from './containers/Values';
import Services from './containers/Services';

import Credits from './containers/Credits';
import CreditsPhotography from './containers/CreditsPhotography';

import Journal from './containers/Journal';
import Journal2 from './containers/Journal2';

import PGrid from './containers/PGrid';
import PList from './containers/PList';
import PDetails from './containers/PDetails';
import Marmalade from './containers/Marmalade';

import NoPage from './containers/NoPage';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

function Layout(){
	return(
		<Router >
			<Switch>
				<Route exact path={`${process.env.PUBLIC_URL}/`} component={Home}/>
				<Route exact path={`${process.env.PUBLIC_URL}/about`} component={About}/>
				<Route exact path={`${process.env.PUBLIC_URL}/values`} component={Values}/>
				<Route exact path={`${process.env.PUBLIC_URL}/services`} component={Services}/>
				
				<Route exact path={`${process.env.PUBLIC_URL}/credits`} component={Credits}/>
				<Route exact path={`${process.env.PUBLIC_URL}/credits/photography`} component={CreditsPhotography}/>

				<Route exact path={`${process.env.PUBLIC_URL}/journal`} component={Journal}/>
				<Route exact path={`${process.env.PUBLIC_URL}/journal/op2`} component={Journal2}/>

				<Route exact path={`${process.env.PUBLIC_URL}/project/grid/:category?`} component={PGrid}/>
				<Route exact path={`${process.env.PUBLIC_URL}/project/detail/:category?`} component={PList}/>

				<Route exact path={`${process.env.PUBLIC_URL}/project/details`} component={PDetails}/>					
				<Route exact path={`${process.env.PUBLIC_URL}/project/:slug`} component={Marmalade}/>		

				<Route exact path={`*`} component={NoPage}/>			
			</Switch>
		</Router>
	)
}
export default Layout;


// WEBPACK FOOTER //
// ./src/Layout.js